var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 3H15C15.5523 3 16 3.44772 16 4C16 4.55228 15.5523 5 15 5H9C7.89543 5 7 5.89543 7 7V17C7 18.1046 7.89543 19 9 19H15C15.5523 19 16 19.4477 16 20C16 20.5523 15.5523 21 15 21H9C6.79086 21 5 19.2091 5 17V7C5 4.79086 6.79086 3 9 3Z",
    fill: "#0069AA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2929 8.29289C16.6834 7.90237 17.3166 7.90237 17.7071 8.29289L21.7071 12.2929C22.0976 12.6834 22.0976 13.3166 21.7071 13.7071L17.7071 17.7071C17.3166 18.0976 16.6834 18.0976 16.2929 17.7071C15.9024 17.3166 15.9024 16.6834 16.2929 16.2929L18.5858 14H10C9.44772 14 9 13.5523 9 13C9 12.4477 9.44772 12 10 12H18.5858L16.2929 9.70711C15.9024 9.31658 15.9024 8.68342 16.2929 8.29289Z",
    fill: "#0069AA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.aff285ad5353b0de6104194dd3f84eaf.svg";
export { ForwardRef as ReactComponent };